// Import dayjs locales statically to avoid webpack processing type definition files
import 'dayjs/locale/en'
import 'dayjs/locale/es'
import 'dayjs/locale/fr'
import 'dayjs/locale/pt'
import 'dayjs/locale/he'
import dayjs from '../../../utils/dayjs'
import { initI18n } from './i18n'

export const initLanguage = async (selectedLanguage: string): Promise<boolean> => {
  try {
    // Define a mapping of language codes to dayjs locale names
    // The locales are already imported statically above, so we just need to set them
    const dayjsLocaleMap: { [key: string]: string } = {
      en: 'en',
      es: 'es',
      fr: 'fr',
      pt: 'pt',
      he: 'he',
    }

    // Get the appropriate dayjs locale name
    const dayjsLocale = dayjsLocaleMap[selectedLanguage] || selectedLanguage

    // Set the dayjs locale (locales are already loaded via static imports)
    dayjs.locale(dayjsLocale)
    console.log(`initLanguage.ts:: dayjs language was changed to: ${dayjsLocale}`)

    // Initialize i18n and set the language.
    await initI18n(selectedLanguage)
    console.log(`initLanguage.ts:: success locale: ${selectedLanguage}`)

    return true
  } catch (e) {
    console.error('initLanguage.ts:: error', e)
    return false
  }
}
